/**
 * KeepSpatial API Client
 * Handles communication with the Keep Spatial API
 */

import { getApiBase, getApiKey } from './config.js';

/**
 * Fetch model data for a SKU
 * @param {string} sku - Product SKU
 * @param {string} [apiKey] - Optional API key override
 * @returns {Promise<import('./types.js').ModelData|null>}
 */
export async function fetchModel(sku, apiKey) {
  const key = apiKey || getApiKey();

  if (!key) {
    console.error('[KeepSpatial] No API key configured');
    return null;
  }

  try {
    const response = await fetch(`${getApiBase()}/products/${encodeURIComponent(sku)}`, {
      method: 'GET',
      headers: {
        'X-Keep-Spatial-Key': key,
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        console.error('[KeepSpatial] Invalid API key');
      }
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('[KeepSpatial] API error:', error);
    return null;
  }
}

/**
 * Record a hit for AR view
 * @param {string} sku - Product SKU
 * @param {string} [apiKey] - Optional API key override
 * @returns {Promise<boolean>}
 */
export async function recordHit(sku, apiKey) {
  const key = apiKey || getApiKey();

  if (!key) {
    return false;
  }

  try {
    const response = await fetch(`${getApiBase()}/products/${encodeURIComponent(sku)}/hit`, {
      method: 'POST',
      headers: {
        'X-Keep-Spatial-Key': key,
      },
    });

    return response.status === 204;
  } catch (error) {
    console.error('[KeepSpatial] Hit recording failed:', error);
    return false;
  }
}
